/*
  <reading-progress data-target=".article__content">
    Tracks scroll position relative to a target element and exposes
    progress via the --progress CSS custom property (0% to 100%).

  Default target: ".article__content". Override via data-target.
  Skips on reduced-motion users only for the visual transition (CSS-side).
*/

(() => {
  if (customElements.get('reading-progress')) return;

  class ReadingProgress extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._raf = null;
    }

    connectedCallback() {
      const targetSelector = this.getAttribute('data-target') || '.article__content';
      this._target = document.querySelector(targetSelector);
      if (!this._target) {
        this.style.display = 'none';
        return;
      }
      this._measure();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _measure() {
      const rect = this._target.getBoundingClientRect();
      this._top = window.scrollY + rect.top;
      this._height = this._target.offsetHeight;
    }

    _onResize() {
      this._measure();
      this._update();
    }

    _onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        this._update();
      });
    }

    _update() {
      const viewportH = window.innerHeight;
      const scrolled = window.scrollY + viewportH - this._top;
      const total = this._height;
      let pct = 0;
      if (total > 0) {
        pct = Math.max(0, Math.min(100, (scrolled / total) * 100));
      }
      this.style.setProperty('--progress', pct.toFixed(2) + '%');
    }
  }

  customElements.define('reading-progress', ReadingProgress);
})();
